import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { SkeletonLoader } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';

const defaultSkeletonImage = (props)=>/*#__PURE__*/ React.createElement("svg", swcHelpers.extends({}, props, {
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        height: "280"
    }), /*#__PURE__*/ React.createElement("rect", {
        width: "100%",
        height: "30",
        rx: "5",
        fill: "currentColor",
        y: "10"
    }), /*#__PURE__*/ React.createElement("rect", {
        width: "40%",
        height: "50",
        rx: "5",
        fill: "currentColor",
        y: "60"
    }), /*#__PURE__*/ React.createElement("rect", {
        width: "100%",
        height: "60",
        rx: "5",
        fill: "currentColor",
        y: "120"
    }), /*#__PURE__*/ React.createElement("rect", {
        width: "60%",
        height: "30",
        rx: "5",
        fill: "currentColor",
        y: "190"
    }), /*#__PURE__*/ React.createElement("rect", {
        width: "100%",
        height: "40",
        rx: "5",
        fill: "currentColor",
        y: "230"
    }))
;
const StoreTile = (_param)=>{
    var { className , children , loading , SkeletonImage: CustomSkeletonImage , variant ='default'  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "children",
        "loading",
        "SkeletonImage",
        "variant"
    ]);
    const { getLabel  } = useIntl();
    const SkeletonImage = defaultSkeletonImage !== null && defaultSkeletonImage !== void 0 ? defaultSkeletonImage : CustomSkeletonImage;
    return /*#__PURE__*/ React.createElement("article", swcHelpers.extends({}, rest, {
        className: classnames('store-tile', className, {
            'store-tile--variant-bordered': variant === 'bordered',
            'store-tile--variant-ghosted': variant === 'ghosted'
        })
    }), loading ? /*#__PURE__*/ React.createElement("div", {
        className: "store-tile__skeleton-loader"
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null, /*#__PURE__*/ React.createElement(SkeletonImage, {
        "aria-label": getLabel('common.loadingText')
    }))) : children);
};
var StoreTile$1 = StoreTile;

export { StoreTile$1 as default };
//# sourceMappingURL=StoreTile.js.map
